/* Korean initialisation for the jQuery calendar extension. */
/* Written by DaeKwon Kang (ncrash.dk@gmail.com), Edited by Genie and Myeongjin Lee. */
( function( factory ) {
    factory( jQuery.datepicker );
}( function( datepicker ) {

    const changeYearButtons = function (element) {
        const $this = $(this);

        setTimeout(function () {
            const widgetHeader = $this.find('.jui-datepicker-header');

            const prevYrBtn = $(`<a class="jui-datepicker-prev jui-corner-all jui-datepicker-year-prev" 
                                    data-handler="prev" data-event="click" title="이전연도"
                                    ><span class="jui-icon jui-icon-circle-triangle-w">이전연도</span></a>`);
            prevYrBtn.on('click', function () {
                $.datepicker._adjustDate($this, -1, 'Y');

                setTimeout(function(){
                    $('.jui-datepicker-year-prev').focus();
                }, 100);
            });
            const nextYrBtn = $(`<a class="jui-datepicker-next jui-corner-all jui-datepicker-year-next" 
                                    data-handler="next" data-event="click" title="다음연도"
                                    ><span class="jui-icon jui-icon-circle-triangle-e">다음연도</span></a>`);
            nextYrBtn.on('click', function () {
                $.datepicker._adjustDate($this, +1, 'Y');

                setTimeout(function(){
                    $('.jui-datepicker-year-next').focus();
                }, 100);
            });

            $('.jui-datepicker-prev:not(.jui-datepicker-year-prev)').on('click', function(e){
                setTimeout(function(){
                    $('.jui-datepicker-prev:not(.jui-datepicker-year-prev)').focus();
                }, 100);
            });
            $('.jui-datepicker-next:not(.jui-datepicker-year-next)').on('click', function(e){
                setTimeout(function(){
                    $('.jui-datepicker-next:not(.jui-datepicker-year-next)').focus();
                }, 100);
            });

            nextYrBtn.prependTo(widgetHeader);
            prevYrBtn.prependTo(widgetHeader);

            widgetHeader.find('a').each(function(idx, obj){
                if(!$(obj).attr('href')){
                    $(obj).attr({href: '#none', role: 'button'});
                }
            });

            $this.find('.jui-datepicker-current-day').find('a').attr('title', '선택됨');

            $('.jui-state-default').on('click', function(e){
                setTimeout(function(){
                    $('.jui-state-active').focus();
                }, 100);
            });

        }, 1);
    };

    datepicker.regional.ko = {
        closeText: "닫기",
        prevText: "이전달",
        nextText: "다음달",
        currentText: "오늘",
        monthNames: [ "1월","2월","3월","4월","5월","6월",
            "7월","8월","9월","10월","11월","12월" ],
        monthNamesShort: [ "1월","2월","3월","4월","5월","6월",
            "7월","8월","9월","10월","11월","12월" ],
        dayNames: [ "일요일","월요일","화요일","수요일","목요일","금요일","토요일" ],
        dayNamesShort: [ "일","월","화","수","목","금","토" ],
        dayNamesMin: [ "일","월","화","수","목","금","토" ],
        weekHeader: "주",
        dateFormat:"yy.mm.dd",
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: true,
        yearSuffix: "년",
        showOtherMonths: true,
        selectOtherMonths: true,
        beforeShow: changeYearButtons,
        onChangeMonthYear: changeYearButtons,
        onSelect: changeYearButtons,
    };
    datepicker.setDefaults( datepicker.regional.ko );

    return datepicker.regional.ko;

} ) );

(function($){
    $.extend($.datepicker, {
        _inlineDatepicker2: $.datepicker._inlineDatepicker,
        _inlineDatepicker: function(target, inst){
            this._inlineDatepicker2(target, inst);

            const beforeShow = $.datepicker._get(inst, 'beforeShow');
            if(beforeShow){
                beforeShow.apply(target, [target, inst]);
            }
        }
    });
})(jQuery);